import {StorageUtil} from "../../../common/Auth";
import {api} from "../../../common/config";
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import {store} from "../../../store/store";

export default {
    name: 'editNote',
    data() {
        return {
            note: { bookName: '', bookId: 0, typeId: 0 },
            errorTips: "",
            content: "",
            idCard: store.func.getUserIdCard(),
            readerId: store.func.getUserReaderId(),
            isSave: false,
            noteId:0,
        }
    },
    mounted() {
        this.note.bookName = this.$route.query.bookName;
        this.note.bookId = this.$route.query.bookId;
        this.note.typeId = this.$route.query.typeId;
        this.noteId = this.$route.query.noteId;
        var readingNote = '';
        if(StorageUtil.getObject("noteContentEdit")){
            readingNote = StorageUtil.getObject("noteContentEdit").readingNote;
        }
        if(this.note.typeId == 2){
          this.content = readingNote;
        }
    },
    methods: {
        save() {
            var content = this.content.trim();
            if (content.length == 0) {
                this.errorTips = "笔记内容不能为空！";
                return;
            } else if (content.length > 1000) {
                this.errorTips = "字数超过1000字！";
                return;
            }
            if (this.isSave) {
                return;
            }
            this.isSave = true;
            //保存
            var submitData = {};
            var url = api.note.update;
            if (this.note.typeId == 1) {
              url = api.note.add;
                submitData = {
                    idCard: this.idCard,
                    bookId: this.note.bookId,
                    readingNote: this.content.trim(),
                };
            } else {
                submitData = {
                    id: this.noteId,
                    readingNote: this.content.trim(),
                };
            }
          ajaxUtil.ajaxJson(url, submitData, 'POST', (data) => { //成功
            this.errorTips = "保存成功！";
            setTimeout(()=>{
                this.$router.push({path:'/notecontent',query:{ bookId: this.note.bookId, readerId: this.readerId, bookName: this.note.bookName }});
            },2000);
            }, (result) => { //失败
                this.errorTips = "保存失败！";
                this.isSave = false;
            }, this);

        },
    }
}

